import { autobind } from 'core-decorators';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable, computed } from 'mobx';
import { useRequest } from 'ahooks';
import routeConfigs from '../app-router/route-configs';
import { useEffect } from 'react';

class ListStore extends BaseStore {
  // 当前显示的文章 ID
  @observable articleId = null;

  // 列表加载状态
  @observable fetchList;

  // 列表数据
  @observable listData = [];

  constructor(options) {
    super();
    Object.assign(this, options);
  }

  /**
   * 是否有列表数据
   * @returns {boolean}
   */
  @computed
  get hasData() {
    return this.listData.length > 0;
  }

  /**
   * 跳转至列表页
   * @param {number|string} id - 列表ID
   */
  @autobind
  navToList(id) {
    const path = routeConfigs.LIST.path.replace(':id', id);
    this.redirect(path);
    // window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  use() {
    super.use();

    this.articleId = this.$routeParams.id ? parseInt(this.$routeParams.id, 10) : null;

    useEffect(() => {
      // 数据请求
      // this.fetchList = useRequest(this.fetchListDataAsync, {
      //   onSuccess: data => {
      //     this.listData = data;
      //   },
      //   onError: e => {
      //     console.error('获取列表失败', e);
      //   }
      // });
      this.articleId&&window.scrollTo({ top: 550, behavior: 'smooth' });
    }, [this.articleId]);

    useMount(() => {
      // 可以在这里执行挂载后的逻辑
      console.log('List page mounted');
    });
  }
}

export default ListStore;
